/*
 * @Author: 吴文洁
 * @Date: 2019-09-06 15:29:50
 * @LastEditors: 吴文洁
 * @LastEditTime: 2019-09-06 18:21:56
 * @Description: 
 */
import throttle from './throttle';
import store from '@/store';

export const isRunningBrowser = typeof window !== void 0;
export const supportsIntersectionObserver = isRunningBrowser && 'IntersectionObserver' in window;

const isIntersecting = (entry: any) => {
  if (supportsIntersectionObserver) {
    return entry.isIntersecting || entry.intersectionRatio > 0
  } else {
    const rect = entry.getBoundingClientRect();
    return rect.top < document.documentElement.clientHeight;
  }
};

export const setObserver = (action: any, value: any) => {
  if (supportsIntersectionObserver) {
    return new IntersectionObserver((entries) => {
      entries.forEach((entry: any) => {
        const { target } = entry;
        if (isIntersecting(entry)) {
          target.io.unobserve(target)
          store.dispatch(action, value);
          target.timer = window.setTimeout(() => {
            store.dispatch(action, !value);
          }, 5000);
        }
      });
    });
  } else {
    return {
      observe: (el: any) => {
        el.scrollEvent = throttle(() => {
          if (isIntersecting(el)) {
            document.removeEventListener('scroll', el.scrollEvent);
            store.dispatch(action, value);
            el.timer = window.setTimeout(() => {
              store.dispatch(action, !value);
            }, 5000);
          }
        }, 300);
        document.addEventListener('scroll', el.scrollEvent);
      },
      unobserve: (el: any) => {
        window.clearTimeout(el.timer);
        document.removeEventListener('scroll', el.scrollEvent);
      }
    }
  }
}